import Vue from "vue";
import Component from "vue-class-component";
import _ from "lodash";
import EventBus from "front-component/EventBus";
import { MessageType } from "element-ui/types/message";

@Component
export default class FlashMessage extends Vue {
    public created(): void {
        EventBus.$on("error-alert", this.showErrorMessage);
        EventBus.$on("success-alert", this.showSuccessMessage);
    }

    private beforeDestroy(): void {
        EventBus.$off("error-alert", this.showErrorMessage);
        EventBus.$off("success-alert", this.showSuccessMessage);
    }

    private showErrorMessage(message: any): void {
        this.showMessage("error", message);
    }

    private showSuccessMessage(message: any): void {
        this.showMessage("info", message);
    }

    private showMessage(type: MessageType, message: any): void {
        if (message) {
            this.$message({
                type,
                message: this.objectToMessage(message),
            });
        }
    }

    private objectToMessage(message: any): string {
        if (message && typeof message === "object" && message.hasOwnProperty("message")) {
            return this.objectToMessage(_.invoke(this.$options.filters, "trans", message.message));
        }

        if (!message || typeof message === "string") {
            return message || "";
        }

        let finalMessage: string = "";
        for (let [key, value] of Object.entries(message)) {
            if (key !== parseInt(key, 10).toString()) {
                finalMessage += _.invoke(this.$options.filters, "trans", key);
            }

            if (typeof value !== "string") {
                value = this.objectToMessage(value);
            }

            value = _.invoke(this.$options.filters, "trans", value);
            if (typeof value === "string" && value.length > 0) {
                finalMessage += (value[0] !== ":" ? ": " : "") + value;
            }
        }

        return finalMessage;
    }

    public render(): string {
        return "";
    }
}
